import { render } from "./ShipWiseDeck.vue?vue&type=template&id=cd3f756c"
const script = {}

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__